import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=59a7f1a6&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"
import style0 from "./tree.vue?vue&type=style&index=0&id=59a7f1a6&lang=scss&scoped=true"
import style1 from "./tree.vue?vue&type=style&index=1&id=59a7f1a6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a7f1a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a7f1a6')) {
      api.createRecord('59a7f1a6', component.options)
    } else {
      api.reload('59a7f1a6', component.options)
    }
    module.hot.accept("./tree.vue?vue&type=template&id=59a7f1a6&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('59a7f1a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataCenter/archives/tree.vue"
export default component.exports